let background = `
<g transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M320 1425 l0 -1235 1240 0 1240 0 -2 1233 -3 1232 -1237 3 -1238 2 0
-1235z m2440 1216 c0 -2 -113 -116 -250 -253 l-251 -248 -702 0 -702 0 -247
247 c-136 136 -250 244 -254 240 -4 -4 101 -117 234 -250 l242 -243 1 -709 0
-710 -242 -242 c-134 -133 -240 -246 -236 -250 4 -4 117 102 250 235 l242 242
710 0 710 0 242 -242 c133 -133 246 -239 250 -235 4 4 -104 119 -240 255
l-247 247 0 699 0 699 254 254 254 255 0 -1206 -1 -1206 -21 -5 c-12 -3 -559
-4 -1216 -3 l-1195 3 -3 1195 c-1 657 0 1204 2 1215 5 20 13 20 1211 20 663 0
1205 -2 1205 -4z m-504 -537 c-3 -9 -6 -324 -6 -700 l0 -684 -695 0 -695 0 0
700 0 700 701 0 c635 0 701 -1 695 -16z"/>
</g>`

export default [
  {
    title: "Diagnostic",
    childs: [
      {
        label: "Vérification produit",
        type: "checkboxs",
        valueKeyname: "verification_produit",
        values: [
          {label: "Controle tension secteur", value: "controle_tension_secteur"},
          {label: "Localisation du produit", value: "localisation_produit"},
          {label: "Température controlé du réfrégérateur/congélateur", value: "temperature_controle"},
          {label: "Contrôle de l'évacuation des eaux usées (lavage)", value: "evacuation_eau_usee"},
          {label: "Contrôle température ambiante", value: "controle_temperature_ambiante"},
          {label: "Contrôle de la mise à la terre du produit", value: "mise_a_terre_produit"},
          {label: "Température de consigne du réfrigérateur / Congélateur", value: "temperature_consigne"},
          {label: "Contrôle d'alimentation en eau (side by side, lavage)", value: "controle_alimentation_eau"},
          {label: "Contrôle des normes d'encastrement (Four, réfrigérateur)", value: "controle_norme_encastrement"},
          {label: "Hottes: Evacuation des fumées", value: "hottes_evacuation_fumees"},
	  {label: "Hass IQC effectué ?", value: "hass_iqc"},
	  {label: "Hass OQC effectué ?", value: "hass_oqc"},
        ],
        required: true
      },
      {
        class: "pt-4 border-t",
        label: "Description de la panne constatée",
        type: "select",
        valueKeyname: "description_panne_constatee",
        values: [
          {label: "Défaut non reproduit", value: "defaut_non_reproduit"},
          {label: "Problème constant", value: "probleme_constant"},
          {label: "Problème intermittent", value: "probleme_intermittent"},
          {label: "Exterieur (Environnement)", value: "exterieur"},
        ],
        required: true
      },
    ]
  },
  {
    title: "Réparation",
    childs: [
      {
        label: "Mise à jour Soft Main",
        valueKeyname: "maj",
        type: "text",
        required: true
      },
      {
        label: "Etat de l'intervention",
        type: "select",
        valueKeyname: "etat_intervention",
        values: [
          {label: "Appareil rapatrié en atelier", value: "appareil_rapatrie_atelier"},
          {label: "Intevention finalisée", value: "intervention_finalisee"},
          {label: "Intervention non finalisée (Nouvelle intervention nécessaire)", value: "intervention_non_finalisee"},
        ],
        required: true,
        onChange: `if (this.getChildByValueKeyname('etat_intervention').result === 'intervention_non_finalisee') {
          this.getChildByValueKeyname('nouvelle_date_intervention').hide = false
        } else {
          this.getChildByValueKeyname('nouvelle_date_intervention').hide = true
        }`
      },
      {
        label: "Nouveau rendez-vous",
        type: "datetime",
        valueKeyname: "nouvelle_date_intervention",
        hide: true,
        required: true
      },
      {
        label: "Si appareil rapatrié en atlier, merci de dessiner les éventuels chocs, rayures contastés avant enlèvement",
        valueKeyname: "dessin_choc",
        type: "draw",
        background: background
      },
    ]
  },
  {
    title: "Contrôle final",
    childs: [
      {
        label: "",
        valueKeyname: "controle_final",
        type: "checkboxs",
        values: [
          {label: "Mise sous tension", value: "mise_sous_tension"},
          {label: "Vérification alignement portes & remise à niveau", value: "alignement_porte_remise_a_niveau"},
          {label: "Nettoyage", value: "nettoyage"},
          {label: "Remise en place des réglages client", value: "reglage_client"},
          {label: "Remise en place arrivée / évacuation des eaux", value: "arrivee_evacation_eau"},
        ],
        required: true
      },
    ]
  },
]
